export default "__VITE_ASSET__gjVEOEsR__"